/**
 * @generated SignedSource<<079fc80f688f60e647c50ea1c5f4349a>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                        "disabledDate": {
                            "eq": null
                        }
                    }
                }
            ],
            "concreteType": "AssignmentTypeConnection",
            "kind": "LinkedField",
            "name": "assignmentTypes",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssignmentTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssignmentType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": "assignmentTypes(where:{\"disabledDate\":{\"eq\":null}})"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "EditEventAssignmentTypesQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditEventAssignmentTypesQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "8733d34be2e5578841ec8bb46024444d",
            "id": null,
            "metadata": {},
            "name": "EditEventAssignmentTypesQuery",
            "operationKind": "query",
            "text": "query EditEventAssignmentTypesQuery {\n  assignmentTypes(where: {disabledDate: {eq: null}}) {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "e0c3015843155f90edece51db46ea882";
export default node;
